import { capitalizeInitials } from '@shared/utils';

import { Role } from './role';

export interface User {
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  photoId?: number;
  workPhone?: string;
  mobilePhone?: string;
  role?: Role;
  email: string;
  locked?: boolean;
  createdDate?: string;
  lastModifiedDate?: string;
  /**
   * List of resources user has access to.
   * Only for logged in user
   */
  resources?: string[];
  shortName?: string;
  hasAuthAccount?: boolean;
  anonymization?: boolean;
  jobTitle?: string;
  mobile?: string;
}

export class UserAutoOptionAdapter {
  // TODO: autocomplete doesnt use anyspecific type maybe this is not needed
  static toOption(user: User): any {
    // TODO: create better type
    return !!user && !!user.id
      ? {
          id: user.id,
          label: `${user.firstName} ${user.lastName}`,
          capitals: capitalizeInitials(`${user.firstName} ${user.lastName}`),
          imageId: user.photoId,
          option: user,
        }
      : null;
  }
}

export class UserFormAdapter {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  constructor(source: User) {
    this.id = source.id;
    this.firstName = source.firstName;
    this.lastName = source.lastName;
    this.email = source.email;
    this.role = source.role?.name;
  }
}
